import Vue from 'vue';
import VueRouter from 'vue-router'
import vuetify from './plugins/vuetify';
import App from './App.vue';
import './plugins/axios';
import { routes } from './router.js'
import { EventBus } from './eventBus';


// Create EventBus
EventBus;

Vue.config.productionTip = false;

Vue.use( VueRouter )

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})


new Vue({
  vuetify,
  router,
  render: h => h(App),
}).$mount('#app');
